import React, { useEffect } from 'react';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import authService from '../auth/AuthService';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { logout } from '../store/correcttrackSlice';

export default function Logout() {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    async function logoutUser() {
        await authService.logout();
        dispatch(logout());
        window.location.href = '/';
    }

    useEffect(() => {
        void logoutUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f5f5f5',
            }}
        >
            <Stack spacing={2} alignItems="center">
                <CircularProgress color="primary" />
                <Typography variant="body1" color="text.secondary">
                    {t('logoutPage.loggingOut')}
                </Typography>
            </Stack>
        </Box>
    );
}
